import {lookupActivationKey} from '../../actions/AuthenticationActionCreators';
import qs from 'qs';

async function ensureActivationKey(nextState) {
  let toReturn = {};
  try {
    console.info('Finding user for authenticationKey', nextState);
    const context = nextState.routes[0].getContext();
    let query = nextState.location.query;
    if (!query) {
      query = qs.parse(nextState.location.search.replace(/^[?]/, ''));
    }
    const activationKey = query['activation-key'];

    const activationResult = await context.executeAction(lookupActivationKey, {
      activationKey
    });

    if (!activationResult || !activationResult.emailAddress) {
      toReturn = {
        redirect: '/'
      };
      console.info('Invalid or expired activation-key');
    }
  } catch (ex) {
    console.error('WTF, invalid activation key', ex, nextState.location.query);

    toReturn = {
      redirect: '/'
    };
  }

  return toReturn;
}

export default ensureActivationKey;



// WEBPACK FOOTER //
// ./src/utils/route/ensureActivationKey.js